/* eslint-disable no-case-declarations */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Control } from 'react-redux-form';
import _ from 'lodash';

import { fetchOfferings } from '../../actions';
import { fetchOfferingOrders } from '../../actions/investment';
import arrow from '../../assets/images/select-arrow.svg';

import RoutedHeader from '../Header';
import { LAYOUT, MIN_WIDTH } from '../Layout/enums';

import loadGif from '../../assets/images/loading.gif';

import './index.css';
import FeaturedOffering from './FeaturedOffering';
import StandardOffering from './StandardOffering';


export const OfferingListItems = ({
  layout,
  offerings,
  isOfferingsLoading,
  pendingOrderOfferingIds = [],
  currentFilter,
  showValues,
  currentShowPick,
  filterCallback,
  priorityArray,
}) => {
  const data = [];
  const featured = offerings.filter(offering => offering.featured && offering.status !== 'closed');
  const comingSoon = offerings.filter(offering => (offering.category === 2 || offering.category === 3) && offering.status !== 'closed' && !offering.new && !offering.featured);
  const newOffers = offerings.filter(offering => offering.status !== 'closed' && offering.new && !offering.featured);
  const activeOfferings = offerings.filter(offering => (offering.category !== 2 && offering.category !== 3) && offering.status !== 'closed' && !offering.new && !offering.featured);
  const closedOfferings = offerings.filter(offering => (offering.category !== 2 && offering.category !== 3) && offering.status === 'closed' && !offering.new && !offering.featured);

  const comingSoonOrdered = _.orderBy(comingSoon, v => _.findIndex(priorityArray, x => JSON.stringify(x) === JSON.stringify(['active', v.offerType, v.securityType, v.industry])));
  const newOffersOrdered = _.orderBy(newOffers, v => _.findIndex(priorityArray, x => JSON.stringify(x) === JSON.stringify(['active', v.offerType, v.securityType, v.industry])));
  const activeOfferingsOrdered = _.orderBy(activeOfferings, v => _.findIndex(priorityArray, x => JSON.stringify(x) === JSON.stringify(['active', v.offerType, v.securityType, v.industry])));
  const closedOfferingsOrdered = _.orderBy(closedOfferings, v => _.findIndex(priorityArray, x => JSON.stringify(x) === JSON.stringify(['active', v.offerType, v.securityType, v.industry])));

  // eslint-disable-next-line default-case
  switch (currentFilter) {
    case 'Offer Status':
      if (currentShowPick === 'All') {
        data.push(...comingSoonOrdered);
        data.push(...newOffersOrdered);
        data.push(...activeOfferingsOrdered);
        data.push(...closedOfferingsOrdered);
      } else if (currentShowPick === 'Upcoming') {
        data.push(...comingSoonOrdered);
      } else if (currentShowPick === 'Active') {
        data.push(...comingSoonOrdered);
        data.push(...newOffersOrdered);
        data.push(...activeOfferingsOrdered);
      } else if (currentShowPick === 'Closed') {
        data.push(...closedOfferingsOrdered);
      }
      break;
    case 'Offering Type':
      if (currentShowPick === 'All') {
        data.push(...comingSoonOrdered);
        data.push(...newOffersOrdered);
        data.push(...activeOfferingsOrdered);
        data.push(...closedOfferingsOrdered);
      } else {
        data.push(...comingSoonOrdered.filter(v => v.offerType === currentShowPick));
        data.push(...newOffersOrdered.filter(v => v.offerType === currentShowPick));
        data.push(...activeOfferingsOrdered.filter(v => v.offerType === currentShowPick));
        data.push(...closedOfferingsOrdered.filter(v => v.offerType === currentShowPick));
      }
      break;
    case 'Security Type':
      if (currentShowPick === 'All') {
        data.push(...comingSoonOrdered);
        data.push(...newOffersOrdered);
        data.push(...activeOfferingsOrdered);
        data.push(...closedOfferingsOrdered);
      } else {
        data.push(...comingSoonOrdered.filter(v => v.securityType === currentShowPick));
        data.push(...newOffersOrdered.filter(v => v.securityType === currentShowPick));
        data.push(...activeOfferingsOrdered.filter(v => v.securityType === currentShowPick));
        data.push(...closedOfferingsOrdered.filter(v => v.securityType === currentShowPick));
      }
      break;
    case 'Industry Type':
      if (currentShowPick === 'All') {
        data.push(...comingSoonOrdered);
        data.push(...newOffersOrdered);
        data.push(...activeOfferingsOrdered);
        data.push(...closedOfferingsOrdered);
      } else {
        data.push(...comingSoonOrdered.filter(v => v.industry === currentShowPick));
        data.push(...newOffersOrdered.filter(v => v.industry === currentShowPick));
        data.push(...activeOfferingsOrdered.filter(v => v.industry === currentShowPick));
        data.push(...closedOfferingsOrdered.filter(v => v.industry === currentShowPick));
      }
      break;
  }

  return (!isOfferingsLoading && offerings && offerings[0] ?
    <div styleName="offerViewWidthRestriction">
      {featured[0] ? <FeaturedOffering layout={layout} offering={featured[0]} /> : null}
      <div style={{ display: 'flex', flexDirection: 'row', marginTop: featured ? 20 : 0 }}>
        <div style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              fontWeight: 400,
              fontSize: 32,
            }}
        >
        Offers
        </div>
        <div style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                alignItems: 'flex-end',
              }}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginRight: 10 }}>
              <span style={{ fontSize: 18, marginRight: 5 }}>Order By:</span>
              <div styleName="filterSelectWrapper" style={{ display: 'inline-block', width: 200 }}>
                <Control.select
                  styleName="filterSelect"
                  model="filter"
                  onChange={(e) => {
                    const pickedVal = e.target.value;
                    // eslint-disable-next-line default-case
                    switch (pickedVal) {
                      case 'Offer Status':
                        filterCallback({ showValues: ['All', 'Upcoming', 'Active', 'Closed'], currentShowPick: 'All', currentFilter: pickedVal });
                        break;
                      case 'Offering Type':
                          filterCallback({
                            showValues: ['All', 'Reg A+', 'Reg A+ & NASDAQ Public Listing', 'Reg D: 506(b)', 'Reg D: 506(c)', 'Prospectus: S-1', 'Prospectus: S-3', 'Prospectus: S-11'],
                            currentShowPick: 'All',
                            currentFilter: pickedVal,
                          });
                          break;
                      case 'Security Type':
                        filterCallback({
                          showValues: ['All', 'Common Stock', 'Common Stock: Non-Traded', 'Equity', 'Preferred Stock', 'Preferred Stock: Non-Traded'],
                          currentShowPick: 'All',
                          currentFilter: pickedVal,
                        });
                        break;
                      case 'Industry Type':
                        filterCallback({
                          showValues: ['All', 'Real Estate', 'Real Estate (REIT)', 'Deathcare', 'Life Insurance Settlements', 'Brewery', 'Restaurant', 'Autonomous Security'],
                          currentShowPick: 'All',
                          currentFilter: pickedVal,
                        });
                        break;
                    }
                  }}
                >
                  <option value="Offer Status">Offer Status</option>
                  <option value="Offering Type">Offering Type</option>
                  <option value="Security Type">Security Type</option>
                  <option value="Industry Type">Industry Type</option>
                </Control.select>
                <img
                  styleName="filterSelectArrow"
                  src={arrow}
                  alt="arrow"
                />
              </div>
            </div>
            <div>
              <span style={{ fontSize: 18, marginRight: 5 }}>Show:</span>
              <div styleName="filterSelectWrapper" style={{ display: 'inline-block', width: 200 }}>
                <Control.select
                  styleName="filterSelect"
                  model="filter"
                  onChange={(e) => {
                    filterCallback({ currentShowPick: e.target.value });
                  }}
                >
                  {showValues && showValues.map(val => <option value={val} key={`filterSelectWrapper${val}`}>{val}</option>)}
                </Control.select>
                <img
                  styleName="filterSelectArrow"
                  src={arrow}
                  alt="arrow"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div styleName="standOfferList">
        {data.map(offering => (
          <StandardOffering
            key={offering.id}
            layout={layout}
            offering={offering}
            showPendingStatus={pendingOrderOfferingIds.includes(offering.id)}
          />))}
      </div>
      <div style={{ paddingBottom: 20 }}>
        <p style={{
          fontWeight: 'bold',
          fontSize: 18,
          color: '#EE624D',
        }}
        >Closed Offers
        </p>
        <p style={{
           marginTop: 10,
                  fontStyle: 'italic',
                  fontWeight: 'normal',
                  fontSize: 18,
                  color: '#767676',
          }}
        >
          <sup>*</sup>Closed offers include total capital raised in the offering by all selling group members or placement agents.
          <br />
          The amount reflects the total amount each company raised in the offering.
        </p>
      </div>
    </div> : <img styleName="loadingGif" src={loadGif} alt="Loading" />
  );
};

const getPriorityArray = () => {
  const variationVectors = {
    status: ['active', 'closed'],
    offerType: ['Reg A+', 'Reg A+ & NASDAQ Public Listing', 'Reg D: 506(b)', 'Reg D: 506(c)', 'Prospectus: S-1', 'Prospectus: S-3', 'Prospectus: S-11'],
    securityType: ['Common Stock', 'Common Stock: Non-Traded', 'Equity', 'Preferred Stock', 'Preferred Stock: Non-Traded'],
    industry: ['Real Estate', 'Real Estate (REIT)', 'Deathcare', 'Life Insurance Settlements', 'Brewery', 'Restaurant', 'Autonomous Security'],
  };
  const f = (a, b) => [].concat(...a.map(aa => b.map(bb => [].concat(aa, bb))));
  const cartesian = (...args) => {
    const [a, b, ...rest] = args;
    return b ? cartesian(f(a, b), ...rest) : a;
  };

  const vals = Object.values(variationVectors);
  const retVal = cartesian(...vals);
  return retVal;
};
class OfferingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      currentFilter: 'Offer Status',
      // eslint-disable-next-line react/no-unused-state
      showValues: ['All', 'Upcoming', 'Active', 'Closed'],
      // eslint-disable-next-line react/no-unused-state
      currentShowPick: 'All',
    };
    this.filterCallback = this.filterCallback.bind(this);
  }

  componentDidMount() {
    this.props.fetchOfferings();
    if (this.props.accountNumber) {
      this.props.fetchOfferingOrders(this.props.accountNumber);
    }
  }

  filterCallback(obj) { this.setState(obj); }

  render() {
    const {
      offerings,
      isOfferingsLoading,
      pendingOrderOfferingIds,
      priorityArray,
    } = this.props;
    return (
      <div styleName="offerViewMain">
        <RoutedHeader />
        <MediaQuery
          minWidth={MIN_WIDTH.DESK}
        >
          <OfferingListItems
            {...this.state}
            filterCallback={this.filterCallback}
            priorityArray={priorityArray}
            layout={LAYOUT.DESK}
            offerings={offerings}
            isOfferingsLoading={isOfferingsLoading}
            pendingOrderOfferingIds={pendingOrderOfferingIds}
          />
        </MediaQuery>
        <MediaQuery
          minWidth={MIN_WIDTH.TAB}
          maxWidth={MIN_WIDTH.DESK - 1}
        >
          <OfferingListItems
            {...this.state}
            filterCallback={this.filterCallback}
            priorityArray={priorityArray}
            layout={LAYOUT.TAB}
            offerings={offerings}
            isOfferingsLoading={isOfferingsLoading}
            pendingOrderOfferingIds={pendingOrderOfferingIds}
          />
        </MediaQuery>
        <MediaQuery
          maxWidth={MIN_WIDTH.TAB - 1}
        >
          <OfferingListItems
            {...this.state}
            filterCallback={this.filterCallback}
            priorityArray={priorityArray}
            layout={LAYOUT.MOB}
            offerings={offerings}
            isOfferingsLoading={isOfferingsLoading}
            pendingOrderOfferingIds={pendingOrderOfferingIds}
          />
        </MediaQuery>
      </div>
    );
  }
}


/**
 * Return list of current user's orders' offering ids
 */
const getPendingOrderOfferingIds = ({ authToken, currentAccount, offeringOrdersByAccount }) => {
  if (!authToken || !currentAccount || !offeringOrdersByAccount[currentAccount]) {
    return [];
  }
  if (offeringOrdersByAccount[currentAccount].isFetching) {
    return [];
  }
  return offeringOrdersByAccount[currentAccount].data
    .filter(({ status }) => status === 'created' || status === 'submitted')
    .map(({ offerId }) => offerId);
};

const mapStateToProps = state => ({
  offerings: state.offerings.data ? state.offerings.data : [],
  isOfferingsLoading: state.offerings.isFetching,

  accountNumber: state.currentAccount,
  pendingOrderOfferingIds: getPendingOrderOfferingIds(state),
  priorityArray: getPriorityArray(),
});

const mapDispatchToProps = {
  fetchOfferings,
  fetchOfferingOrders,
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferingList);



// WEBPACK FOOTER //
// ./src/components/OfferingList/index.js